import { atomWithStorage } from 'jotai/utils';

export const attestationAtom = atomWithStorage('attestation', false);
